import { useEffect, useRef } from 'react'
import { appendChatMessage } from '../components/chat/utils/chatMessageHelpers'

const useChatMessages = ({
  messages,
  dispatch,
  setMessages,
  getMessageId,
  getTime,
}) => {
  const messagesRef = useRef(messages)

  useEffect(() => {
    messagesRef.current = messages
  }, [messages])

  const addMessage = (from, payload) => {
    const updated = appendChatMessage({
      messages: messagesRef.current,
      from,
      payload,
      getMessageId,
      getTime,
    })

    messagesRef.current = updated
    dispatch(setMessages(updated))
  }

  const addAiMessage = (payload) => {
    addMessage('ai', payload)
  }

  const addUserMessage = (payload) => {
    addMessage('user', payload)
  }

  return {
    messagesRef,
    addAiMessage,
    addUserMessage,
  }
}

export default useChatMessages